package br.com.texeratx.boardgametimeapp.data.repository

import br.com.texeratx.boardgametimeapp.core.network.ApiClient
import br.com.texeratx.boardgametimeapp.core.session.SessionManager
import br.com.texeratx.boardgametimeapp.data.model.match.CreateMatchRequest
import br.com.texeratx.boardgametimeapp.data.model.match.MatchListItemDTO
import br.com.texeratx.boardgametimeapp.data.model.match.UpdateMatchRequest
import io.ktor.client.call.body

class MatchRepository(
    private val api: ApiClient,
    private val sessionManager: SessionManager
) {

    suspend fun getMatches(): Result<List<MatchListItemDTO>> = runCatching {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val response = api.get("matches")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun updateMatch(
        matchId: Long,
        body: UpdateMatchRequest
    ): Result<Unit> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            api.put("matches/$matchId", body)
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun getMatchById(matchId: Long): Result<MatchListItemDTO> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val response = api.get("matches/$matchId")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun createMatch(body: CreateMatchRequest): Result<Unit> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            api.post("matches", body)
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun getMatchDetailsById(matchId: Long): Result<MatchListItemDTO> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            val response = api.get("/matches/$matchId/details")
            Result.success(response.body())
        } catch (e: Exception) {
            Result.failure(e)
        }
    }

    suspend fun deleteMatch(matchId: Long): Result<Unit> {
        return try {
            sessionManager.load() ?: return Result.failure(Exception("Sessão expirada"))
            api.delete("matches/$matchId")
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }


}